export default "__VITE_ASSET__BUhUMGp2__"